/**
* Form Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Form Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'form-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const _this = this;

      const heroFormId = $( '.form-hero' ).data( 'form_id' );

      // console.log( heroFormId );
      if ( heroFormId && heroFormId !== '' ) {
        $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
          if ( heroFormId === formId ) {
            const confirmation = $( '.gform_confirmation_message_' + formId );
            const confirmationText = confirmation.text();

            const newConfirmation = `
            <div class="flex">
              <div class="flex-initial mr-3">
                <svg class="icon icon-confirmation-check block w-[28px] h-[28px]"><use xlink:href="#icon-confirmation-check"></use></svg>
              </div>
              <div class="flex-initial flex-grow">
                ${confirmationText}
              </div>
            </div>
            `;

            confirmation.html( newConfirmation );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'form-hero', COMPONENT );
} )( app );
